/** Nhãn «AI» cho dòng gợi ý từ Tra cứu AI / Hub (chưa lưu trang). */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const AiContentLabel: React.FC = () => {
  const { t } = useTranslation();
  return (
    <span
      title={t('bsc.ai.fromAssistant', 'Gợi ý từ Trợ lý BSC — chưa lưu trang')}
      style={{
        flexShrink: 0,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.04em',
        padding: '2px 6px',
        borderRadius: 4,
        backgroundColor: '#0C68E9',
        color: '#fff',
        lineHeight: '14px',
        marginRight: 6,
        verticalAlign: 'middle',
      }}
    >
      AI
    </span>
  );
};

export default AiContentLabel;
